(function ($) {
  'use strict';

  var enviandoFormulario = false;

  $('#form-senha').on('submit', function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submitBtn = $('#cadastrar-senha');
    var submitBtnText = submitBtn.text();
    var dados = new FormData(obj);

    function voltaSubmit() {
      submitBtn.attr('disabled', false);
      submitBtn.text(submitBtnText);
      enviandoFormulario = false;
    }

    if (!enviandoFormulario) {
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: dados,
        contentType: false,
        processData: false,
        beforeSend: function () {
          enviandoFormulario = true;
          submitBtn.attr('disabled', true);
          submitBtn.text('Aguarde...');
        },
        success: function (data) {
          console.log(data);
          if (data == 'ok') {
            location.href = $('#retorno_success').val();
          } else {
            voltaSubmit();
            Toast.fire({
              type: 'error',
              title: 'Não foi possível realizar esta operação.',
            });
          }
        },
        error: function (xhr, type, exception) {
          voltaSubmit();
          Toast.fire({
            type: 'error',
            title: 'Não foi possível realizar esta operação.',
          });
        },
      });
    }
  });
})(jQuery);
